/**
 * Navigation composable for Faraid module
 * Transforms navigation config with i18n translations
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { faraidNavSections } from '../config/navigation.js'

export function useNavigation() {
  const { t } = useI18n()

  // Transform navigation sections with translations
  const navSections = computed(() => {
    return faraidNavSections.map((section) => ({
      title: t(section.titleKey),
      items: section.items.map((item) => ({
        ...item,
        label: t(item.labelKey),
      })),
    }))
  })

  return {
    navSections,
  }
}
